export function validateDepartmentPayload(payload) {
  if (!payload?.countryId) {
    return "El pais es obligatorio.";
  }

  if (!payload?.name?.trim()) {
    return "El nombre es obligatorio.";
  }

  if (!payload?.code?.trim()) {
    return "El codigo es obligatorio.";
  }

  if (payload.code.trim().length > 5) {
    return "El codigo no debe exceder 5 caracteres.";
  }

  return null;
}
